export enum LinkDisplay {
    all,
    auth,
    unauth,
    devAuth,
    devUnauth,
    none
}
